import { render } from "./AdminAccessGroupsDialogSitesManage.vue?vue&type=template&id=52b298c6&scoped=true&ts=true"
import script from "./AdminAccessGroupsDialogSitesManage.vue?vue&type=script&lang=ts"
export * from "./AdminAccessGroupsDialogSitesManage.vue?vue&type=script&lang=ts"

import "./AdminAccessGroupsDialogSitesManage.vue?vue&type=style&index=0&id=52b298c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b298c6"]])

export default __exports__